// removed by extract-text-webpack-plugin
module.exports = {"list":"BulletedList__list___3ZEaQ","listItem":"BulletedList__listItem___-av7I","findingPoint":"BulletedList__findingPoint___2KHdR","headlineText":"BulletedList__headlineText___2vf9L","bullets":"BulletedList__bullets___1vUZj","bulletIcon":"BulletedList__bulletIcon___2-VKO","bullet":"BulletedList__bullet___rQaEU","bulletText":"BulletedList__bulletText___2ET3Z","link":"BulletedList__link___3PfKR"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/BulletedList.css
// module id = 1541
// module chunks = 0